import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { ScrollPanel } from 'primeng/scrollpanel';
import { AppConsts } from 'src/shared/AppConsts';
import { AppComponentBase } from './app-component-base';
import { AppComponent } from './app.component';
import { AuthenticationService } from './_services/authentication.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent extends AppComponentBase implements OnInit, AfterViewInit {

    @Input() reset: boolean;

    model: any[];

    @ViewChild('layoutMenuScroller', { static: false }) layoutMenuScrollerViewChild: ScrollPanel;

    constructor(injector: Injector, public app: AppComponent, private authenticationService: AuthenticationService) { super(injector); }

    ngOnInit() {
        // Obtener el usuario actual y su tenantId
        const currentUser = this.authenticationService?.currentUserValue;
        const tenantId = currentUser?.tenantId;

        // Asignar el menú según el tenantId
        if (tenantId === 6 || tenantId === 8) {
            this.model = this.getMenuMexi();
        } else {
            this.model = this.getMenuFord();
        }
    }

    private getMenuMexi(): any[] {
        return [
            {
                label: this.l('Dashboard'),
                icon: 'pi pi-chart-bar',
                routerLink: ['/app/main/dashboard'],
                permissionName: 'Pages.Tenant.Dashboard'
            },
            {
                label: 'Inventario de secuenciado',
                icon: 'pi pi-calendar',
                routerLink: ['/app/dashboard/inventario-secuenciado']
            },
            {
                label: this.l('CashHistory'),
                icon: 'pi pi-chart-bar',
                routerLink: ['/app/dashboard/historico-cajas'],
                permissionName: 'Pages.Tenant.Caja'
            },
            {
                label: 'Command center',
                icon: 'pi pi-chart-line',
                routerLink: ['/app/catalog/comandas'],
                permissionName: 'Pages.Tenant.Comandas'
            },
            {
                label: this.l('Instances'),
                icon: 'fa fa-th',
                routerLink: ['/app/admin/tenant'],
                permissionName: 'Pages.Tenants',
                visible: AppConsts.isHost
            },
            {
                label: this.l('Administration'), icon: 'pi pi-briefcase',
                items: [
                    {
                        label: this.l('Roles'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/admin/roles'],
                        permissionName: 'Pages.Administration.Roles'
                    },
                    {
                        label: this.l('Pages.Tenant.ConfiguracionNotificaciones'),
                        icon: 'pi pi-bell',
                        routerLink: ['/app/mi-cuenta/notificaciones'],
                        permissionName: 'Pages.Administration.Configuracion.Notificaciones'
                    },
                    {
                        label: this.l('Languages'),
                        icon: 'pi pi-comment',
                        routerLink: ['/app/admin/languages'],
                        permissionName: 'Pages.Administration.Languages'
                    },
                    {
                        label: this.l('Users'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/admin/users'],
                        permissionName: 'Pages.Administration.Users'
                    },
                    {
                        label: this.l('OrgUnits'),
                        icon: 'pi pi-sitemap',
                        routerLink: ['/app/admin/orgunits'],
                        permissionName: 'Pages.Administration.OrgUnits'
                    },
                    {
                        label: this.l('AuditLogs'),
                        icon: 'pi pi-lock',
                        routerLink: ['/app/admin/auditLogs'],
                        permissionName: 'Pages.Administration.AuditLogs'
                    },
                    {
                        label: this.l('Maintenance'),
                        icon: 'fa fa-fw fa-wrench',
                        routerLink: ['/app/admin/maintenance'],
                        permissionName: 'Pages.Administration.Host.Maintenance',
                        visible: !(AppConsts.multiTenancy && AppConsts.tenancyName)
                    },
                    {
                        label: this.l('Host.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/admin/host/settings'],
                        permissionName: 'Pages.Administration.Host.Settings',
                        visible: AppConsts.isHost
                    },
                    {
                        label: this.l('Tenant.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/admin/tenants/settings'],
                        permissionName: 'Pages.Administration.Tenant.Settings'
                    },
                    {
                        label: this.l('EmailGroups'),
                        icon: 'pi pi-envelope',
                        routerLink: ['/app/admin/emailgroups'],
                        permissionName: 'conftcor.0'
                    },
                    {
                        label: this.l('Helps'),
                        icon: 'pi pi-question',
                        routerLink: ['/app/admin/helps'],
                        permissionName: 'Pages.Administration.Helps'
                    }
                ]
            },
            {
                label: this.l('Catalogs'), icon: 'pi pi-briefcase',
                items: [
                    // Grupo: Almacenes
                    {
                        label: this.l('Almacenes'),
                        icon: 'pi pi-home',
                        routerLink: ['/app/catalog/almacen'],
                        permissionName: 'Pages.Tenant.Almacenes'
                    },
                    // Grupo: Móviles/Escaneres
                    {
                        label: this.l('Mobiles'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/mobiles'],
                        permissionName: 'Pages.Tenant.Mobiles'
                    },
                    // Grupo: Escáneres  
                    /*{
                        label: this.l('Pages.Tenant.EscanearMarcarFaltantes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/escanear-marcar-faltantes'],
                        permissionName: 'Pages.Tenant.EscanearMarcarFaltantes'
                    },*/
                    // Grupo: Causas Faltantes
                    {
                        label: this.l('CausaFaltante'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante'],
                        permissionName: 'Pages.Tenant.Catalogs.CausaFaltante'
                    },
                    // Cajas 
                    {
                        label: this.l('Cajas'),
                        icon: 'pi pi-inbox',
                        routerLink: ['/app/catalog/caja'],
                        permissionName: 'Pages.Tenant.Caja'
                    },
                    // Grupo: Modelos
                    {
                        label: this.l('Modelo'),
                        icon: 'pi pi-bookmark',
                        routerLink: ['/app/catalog/modelo'],
                        permissionName: 'Pages.Tenant.Modelo'
                    },
                    // Grupo: Tractor
                    {
                        label: this.l('Tractors'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/catalog/tractors'],
                        permissionName: 'Pages.Tenant.Uploads.Tractor'
                    },
                    // Grupo: Inventario de Grupos
                    {
                        label: this.l('GrupoInventario'),
                        icon: 'pi pi-table',
                        routerLink: ['/app/catalog/grupoinventario'],
                        permissionName: 'Pages.Tenant.GrupoInventario'
                    },
                    // Grupo: Takt Time
                    {
                        label: this.l('TaktTime'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/takttime'],
                        permissionName: 'Pages.Tenant.TaktTime'
                    },
                    // Grupo: Choferes
                    {
                        label: this.l('Chofer'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/catalog/chofer'],
                        permissionName: 'Pages.Tenant.Chofer'
                    },
                    // Grupo: Línea Transportista
                    {
                        label: 'Línea Transportista',
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/lineatransportista'],
                        permissionName: 'Pages.Tenant.LineaTransportista'
                    },
                    // ===== OTROS CATÁLOGOS (mantengo organizados) =====
                    {
                        label: this.l('WorkShifts'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/workshifts'],
                        permissionName: 'Pages.Tenant.WorkShifts'
                    },
                    {
                        label: this.l('Zones'),
                        icon: 'pi pi-map',
                        routerLink: ['/app/catalog/zones'],
                        permissionName: 'Pages.Tenant.Zones'
                    },
                    {
                        label: this.l('Areas'),
                        icon: 'pi pi-map-marker',
                        routerLink: ['/app/catalog/areas'],
                        permissionName: 'Pages.Tenant.Areas'
                    },
                    {
                        label: this.l('LocationTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/locationtypes'],
                        permissionName: 'Pages.Tenant.LocationTypes'
                    },
                    {
                        label: this.l('Locations'),
                        icon: 'pi pi-flag',
                        routerLink: ['/app/catalog/locations'],
                        permissionName: 'Pages.Tenant.Locations'
                    },
                    {
                        label: this.l('Platforms'),
                        icon: 'pi pi-table',
                        routerLink: ['/app/catalog/platforms'],
                        permissionName: 'Pages.Tenant.Platforms'
                    },
                    {
                        label: this.l('Parts'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/parts'],
                        permissionName: 'Pages.Tenant.Parts'
                    },
                    {
                        label: this.l('PartsMexi'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/partsMexi'],
                        permissionName: 'Pages.Tenant.PartsMexi'
                    },
                    {
                        label: this.l('ActivityTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/activitytypes'],
                        permissionName: 'Pages.Tenant.ActivityTypes'
                    },
                    {
                        label: this.l('Providers'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/providers'],
                        permissionName: 'Pages.Tenant.Providers'
                    },
                    {
                        label: this.l('StoreMovementTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/storemovementtypes'],
                        permissionName: 'Pages.Tenant.StoreMovementTypes'
                    },
                    {
                        label: this.l('DamageTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/damagetypes'],
                        permissionName: 'Pages.Tenant.DamageTypes'
                    },
                    {
                        label: this.l('ReasonsSuspension'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/reasonssuspension'],
                        permissionName: 'Pages.Tenant.ReasonsSuspension'
                    },
                    {
                        label: this.l('MarketMaxAndMins'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/marketmaxandmins'],
                        permissionName: 'Pages.Tenant.MarketMaxAndMins'
                    },
                    {
                        label: this.l('CausaFaltante.Edit'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante/edit'],
                        permissionName: 'Pages.Tenant.CausaFaltante.Edit'
                    },
                    {
                        label: this.l('CausaFaltante.Create'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante/create'],
                        permissionName: 'Pages.Tenant.CausaFaltante.Create'
                    },
                    {
                        label: this.l('Routes'),
                        icon: 'pi pi-directions',
                        routerLink: ['/app/catalog/routes'],
                        permissionName: 'Pages.Tenant.Routes'
                    },
                    {
                        label: this.l('Returnables'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/returnables'],
                        permissionName: 'Pages.Tenant.Returnables'
                    },
                    {
                        label: this.l('HoraDeComida'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/hora-comida'],
                        permissionName: 'Pages.Tenant.HoraDeComida'
                    },
                    {
                        label: this.l('HorarioDeProduccion'),
                        icon: 'pi pi-calendar-plus',
                        routerLink: ['/app/catalog/horario-produccion'],
                        permissionName: 'Pages.Tenant.HorarioDeProduccion'
                    },
                    {
                        label: this.l('DiasInhabiles'),
                        icon: 'pi pi-calendar-times',
                        routerLink: ['/app/catalog/dias-inhabiles'],
                        permissionName: 'Pages.Tenant.DiasInhabiles'
                    }
                ]
            },
            {
                label: this.l('Secuenciado'), icon: 'pi pi-briefcase',
                items: [
                    // Grupo: Número de Partes
                    {
                        label: this.l('Uploads.NumeroPartes'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/uploads/numero-partes'],
                        permissionName: 'Pages.Tenant.Uploads.NumeroPartes'
                    },
                    // Grupo: Plan de Producción Frames
                    {
                        label: this.l('PPFrames'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/catalog/ppframes'],
                        permissionName: 'Pages.Tenant.PPFrames'
                    },
                    // Grupo: Plan de Producción Bote
                    {
                        label: this.l('BoatProductionProgram'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/catalog/programaproduccionbote'],
                        permissionName: 'Pages.Tenant.ProgramaProduccionBote'
                    },
                    // Grupo: Commodity Mexis
                    {
                        label: this.l('CommodityMexis'),
                        icon: 'pi pi-th-large',
                        routerLink: ['/app/catalog/commoditymexi'],
                        permissionName: 'Pages.Tenant.CommodityMexis'
                    },
                    // Grupo: Commodities
                    {
                        label: this.l('Commodities'),
                        icon: 'pi pi-th-large',
                        routerLink: ['/app/catalog/commodities'],
                        permissionName: 'Pages.Tenant.Commodities'
                    },
                    // Grupo: Grupos de Commodities
                    {
                        label: this.l('CommodityGroups'),
                        icon: 'pi pi-tags',
                        routerLink: ['/app/catalog/commoditygroups'],
                        permissionName: 'Pages.Tenant.CommodityGroups'
                    },
                    // COMENTADO: Fusión de faldones
                    /*{
                        label: this.l('Detallado.Fusion.Menu'),
                        icon: 'pi pi-copy',
                        routerLink: ['/app/catalog/detallado-fusion'],
                        permissionName: 'Pages.Tenant.Uploads.Detallado.Fusion'
                    },*/
                    // Grupo: Carga Detallada
                    {
                        label: this.l('Uploads.Detallado'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/uploads/detallado'],
                        permissionName: 'Pages.Tenant.Uploads.Detallado'
                    },
                    {
                        label: this.l('Pages.Tenant.Etiquetas'),
                        icon: 'pi pi-tag',
                        routerLink: ['/app/catalog/etiquetas'],
                        permissionName: 'Pages.Tenant.Etiquetas'
                    },
                    // Grupo: Programas escaneados
                    {
                        label: this.l('Pages.Tenant.EscanearMarcarFaltantes'),
                        icon: 'pi pi-tags',
                        routerLink: ['/app/catalog/escanear-marcar-faltantes'],
                        permissionName: 'Pages.Tenant.EscanearMarcarFaltantes'
                    },
                    {
                        label: this.l('ReiniciarSecuencias'),
                        icon: 'pi pi-refresh',
                        routerLink: ['/app/catalog/reiniciar-secuencia-grupo'],
                        permissionName: 'Pages.Tenant.ReiniciarSecuenciaGrupo'
                    },
                    {
                        label: 'Pausar y Reactivar Secuencias',
                        icon: 'pi pi-pause',
                        routerLink: ['/app/catalog/pausar-reactivar-secuencia-grupo'],
                        permissionName: 'Pages.Tenant.PausarReactivarSecuenciaGrupo'
                    },
                    // Secuenciado: Cierre Dolly
                    {
                        label: this.l('CierreDolly'),
                        icon: 'pi pi-lock',
                        routerLink: ['/app/catalog/cierre-dolly'],
                        permissionName: 'Pages.Tenant.CierreDolly'
                    },
                    {
                        label: this.l('AsignarDolly'),
                        icon: 'pi pi-tag',
                        routerLink: ['/app/catalog/asignar-dolly'],
                        permissionName: 'Pages.Tenant.AsignarDolly'
                    },
                    // Grupo: Actualizar Causas Faltantes
                    {
                        label: 'Actualizar Causas Faltantes',
                        icon: 'pi pi-pencil',
                        routerLink: ['/app/catalog/actualizar-causas-faltantes'],
                        permissionName: 'Pages.Tenant.ActualizarCausasFaltantes'
                    },
                    // Grupo: Recuperar Faltantes
                    {
                        label: 'Recuperar Faltantes',
                        icon: 'pi pi-search',
                        routerLink: ['/app/catalog/recuperar-faltantes'],
                        permissionName: 'Pages.Tenant.RecuperarFaltantes'
                    },
                    // Grupo: Consulta de Dolly
                    {
                        label: this.l('Pages.Tenant.ConsultaDolly'),
                        icon: 'pi pi-table',
                        routerLink: ['/app/catalog/consulta-de-dolly'],
                        permissionName: 'Pages.Tenant.ConsultaDolly'
                    },
                    // Grupo: Clasificación de Dollies
                    {
                        label: this.l('DollyClasificacion'),
                        icon: 'pi pi-tag',
                        routerLink: ['/app/catalog/dollyclasificacion'],
                        permissionName: 'Pages.Tenant.DollyClasificacion'
                    },
                    // Grupo: Secuencia Actual de Línea de Producción
                    {
                        label: this.l('SecuenciaActualLineaProduccion.SecuenciaActualLineaProduccion'),
                        icon: 'pi pi-sort-numeric-down',
                        routerLink: ['/app/catalog/secuencia-actual-linea-produccion'],
                        permissionName: 'Pages.Tenant.SecuenciaActualLineaProduccion'
                    },
                    // Grupo: ojo-buffer
                    {
                        label: this.l('OjoBuffer'),
                        icon: 'pi pi-eye',
                        routerLink: ['/app/catalog/ojo-buffer'],
                        permissionName: 'Pages.Tenant.OjoBuffer'
                    },
                    // Grupo: Líneas de Producción
                    {
                        label: this.l('LineaProduccion'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/catalog/lineaproduccion'],
                        permissionName: 'Pages.Tenant.LineaProduccion'
                    },
                    // Grupo: Cruce numero de partes
                    {
                        label: this.l('Pages.Tenant.CargaArchivos'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/catalog/carga-archivos'],
                        permissionName: 'Pages.Tenant.CargaInventarios'
                    }
                ]
            },
            {
                label: 'Auditoría', icon: 'pi pi-shield',
                items: [
                    {
                        label: 'Auditoría de Calidad',
                        icon: 'pi pi-shield',
                        routerLink: ['/app/catalog/auditoria-calidad'],
                        permissionName: 'Pages.Tenant.AuditoriaCalidad'
                    },
                    {
                        label: 'Consulta de auditorías',
                        icon: 'pi pi-search',
                        routerLink: ['/app/catalog/auditoria-calidad-consulta'],
                        permissionName: 'Pages.Tenant.AuditoriaCalidad.Consulta'
                    }
                ]
            },
            {
                label: this.l('Reportes'),
                icon: 'pi pi-chart-bar',
                items: [
                    // Reportes: Inventario Zona Cero
                    {
                        label: this.l('InventarioZonaCero'),
                        icon: 'pi pi-chart-bar',
                        routerLink: ['/app/reports/inventario-zona-cero'],
                        permissionName: 'Pages.Tenant.Reports.InventarioZonaCero'
                    },
                    // Reportes: Faltantes en Dolly
                    {
                        label: 'Faltantes Dolly',
                        icon: 'pi pi-exclamation-triangle',
                        routerLink: ['/app/reports/faltantes-dolly'],
                        permissionName: 'Pages.Tenant.FaltantesDolly'
                    },
                    // Reportes: Productividad
                    {
                        label: this.l('Productividad'),
                        icon: 'pi pi-chart-line',
                        routerLink: ['/app/reports/productividad'],
                        permissionName: 'Pages.Tenant.Productividad'
                    },
                    // Reportes: Tiempo Efectivo por Secuencia y Programa
                    {
                        label: this.l('TiempoEfectivoSecuenciaPrograma.Title'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/reports/tiempo-efectivo-secuencia-programa'],
                        permissionName: 'Pages.Tenant.TiempoEfectivoSecuenciaPrograma'
                    },
                    // Reportes: Sábana Dollys
                    {
                        label: 'Productividad por Dolly',
                        icon: 'pi pi-table',
                        routerLink: ['/app/reports/sabana-dollys'],
                        permissionName: 'Pages.Tenant.Productividad'
                    },
                    // Reportes: KPI
                    {
                        label: 'KPI',
                        icon: 'pi pi-clock',
                        routerLink: ['/app/reports/kpi'],
                        permissionName: 'Pages.Tenant.Reports.KPI'
                    }
                ]
            },
            // Pick-List(Surtido De Material)
            {
                label: this.l('PickList'),
                icon: 'pi pi-list',
                routerLink: ['/app/catalog/pick-list'],
                permissionName: 'Pages.Tenant.PickList'
            },
            {
                label: this.l('Receipts'), icon: 'pi pi-briefcase',
                items: [
                    {
                        label: this.l('Folio'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/uploads/folio'],
                        permissionName: 'Pages.Tenant.Uploads.Folios'
                    },
                ]
            },
            {
                label: this.l('Embarques'), 
                icon: 'pi pi-chart-bar',
                items: [
                    /*{ Se deshabilita del menu para validaciones de funcionamiento
                        label: this.l('Embarques'),
                        icon: 'pi pi-chart-bar',
                        routerLink: ['/app/catalog/dolly-embarques'],
                        permissionName: 'Pages.Tenant.Embarques'
                    },*/
                    {
                        label: this.l('PlanDeCargaManual'),
                        icon: 'pi pi-check-square',
                        routerLink: ['/app/catalog/plan-de-carga-manual'],
                        permissionName: 'Pages.Tenant.PlanDeCargaManual'
                    },
                    {
                        label: this.l('PlanesCarga'),
                        icon: 'pi pi-inbox',
                        routerLink: ['/app/catalog/planes-carga'],
                        permissionName: 'Pages.Tenant.PlanesCarga'
                    }
                    // },
                    // {
                    //     label: this.l('ArriboCajas'),
                    //     icon: 'pi pi-inbox',
                    //     routerLink: ['/app/catalog/arribo-cajas'],
                    //     permissionName: 'Pages.Tenant.ArriboCajas'
                    // },
                    // {
                    //     label: this.l('DescargaCajas'),
                    //     icon: 'pi pi-download',
                    //     routerLink: ['/app/catalog/descarga-cajas'],
                    //     permissionName: 'Pages.Tenant.DescargaCajas'
                    // }
                ]
            },
            {
                label: this.l('PlanTrabajo'),
                icon: 'pi pi-calendar',
                routerLink: ['/app/catalog/plan-trabajo'],
                permissionName: 'Pages.Tenant.PlanTrabajo'
            },
            {
                label: this.l('Uploads.Campus'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.Campus',
                items: [
                    {
                        label: this.l('Uploads.Campus'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/campus'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    },
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/campus/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    },
                    {
                        label: this.l('Uploads.LogSuccess'),
                        icon: 'pi pi-check-circle',
                        routerLink: ['/app/uploads/campus/logsuccess'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    }
                ]
            },
            {
                label: this.l('Uploads.Inbound'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.Inbound',
                items: [
                    {
                        label: this.l('Uploads.Inbound'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/inbound'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    },
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/inbound/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    },
                    {
                        label: this.l('Uploads.LogSuccess'),
                        icon: 'pi pi-check-circle',
                        routerLink: ['/app/uploads/inbound/logsuccess'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    }
                ]
            },
           /* {
                label: this.l('Uploads.NumeroPartes'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.NumeroPartes',
                items: [
                    {
                        label: this.l('Uploads.NumeroPartes'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/numero-partes'],
                        permissionName: 'Pages.Tenant.Uploads.NumeroPartes'
                    }
                ]
            },*/
            {
                label: this.l('Uploads.LogsGenerales'),
                icon: 'pi pi-times-circle',
                permissionName: 'Pages.Tenant.Uploads.LogsGenerales',
                items: [
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/general/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.LogsGenerales'
                    }
                ]
            },
            {
                label: this.l('DownloadSchedules.Downloads'),
                icon: 'pi pi-download',
                permissionName: 'Pages.Tenant.DownloadSchedules',
                items: [
                    {
                        label: this.l('DownloadSchedules.Schedule'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/downloads/schedules'],
                        permissionName: 'Pages.Tenant.DownloadSchedules'
                    },
                    {
                        label: this.l('DownloadDepuration.Depurate'),
                        icon: 'pi pi-check-square',
                        routerLink: ['/app/downloads/depuration'],
                        permissionName: 'Pages.Tenant.DownloadDepuration'
                    }
                ]
            },
            {
                label: this.l('Reports'),
                icon: 'pi pi-file',
                permissionName: 'Pages.Tenant.Reports',
                items: [
                    {
                        label: this.l('Reports.Stocked'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/stocked'],
                        permissionName: 'Pages.Tenant.Reports.Stocked'
                    },
                    {
                        label: this.l('Reports.Download'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/download'],
                        permissionName: 'Pages.Tenant.Reports.Download'
                    },
                    {
                        label: this.l('Reports.Putaway'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/putaway'],
                        permissionName: 'Pages.Tenant.Reports.Putaway'
                    },
                    {
                        label: this.l('Reports.JIT'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/jit'],
                        permissionName: 'Pages.Tenant.Reports.JIT'
                    },
                    {
                        label: this.l('Reports.Empty'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/empty'],
                        permissionName: 'Pages.Tenant.Reports.Empty'
                    },
                    {
                        label: this.l('Reports.LocationStock'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/locationstock'],
                        permissionName: 'Pages.Tenant.Reports.LocationStock'
                    },
                    {
                        label: this.l('Reports.WarehouseMovement'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/warehousemovement'],
                        permissionName: 'Pages.Tenant.Reports.WarehouseMovement'
                    },
                    {
                        label: this.l('Reports.TimeInStock'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/timeinstock'],
                        permissionName: 'Pages.Tenant.Reports.TimeInStock'
                    },
                    {
                        label: this.l('Reports.MaxMin'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/maxmin'],
                        permissionName: 'Pages.Tenant.Reports.MaxMin'
                    },
                    {
                        label: this.l('Reports.Activity'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/activity'],
                        permissionName: 'Pages.Tenant.Reports.Activity'
                    },
                    {
                        label: this.l('Reports.SupplyCardDelivery'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/supplycarddelivery'],
                        permissionName: 'Pages.Tenant.Reports.SupplyCardDelivery'
                    },
                    {
                        label: this.l('Reports.ReasonRestartLog'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/reasonrestartlog'],
                        permissionName: 'Pages.Tenant.Reports.ReasonRestartLog'
                    }
                ]
            },
            {
                label: this.l('SupplyCards'),
                icon: 'pi pi-credit-card',
                permissionName: 'Pages.Tenant.SupplyCards',
                items: [
                    {
                        label: this.l('SupplyCards.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/supplycards/configuration'],
                        permissionName: 'Pages.Tenant.SupplyCards.Settings'
                    },
                    {
                        label: this.l('SupplyCards.Routes'),
                        icon: 'pi pi-directions',
                        routerLink: ['/app/supplycards/routes'],
                        permissionName: 'Pages.Tenant.SupplyCardRoutes'
                    }
                ]
            },
            {
                label: this.l('Locks'),
                icon: 'pi pi-cog',
                permissionName: 'Pages.Tenant.Locks',
                items: [
                    {
                        label: this.l('Locks'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/locks/locks'],
                        permissionName: 'Pages.Tenant.Locks'
                    },
                    {
                        label: this.l('LockLogs'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/locks/logs'],
                        permissionName: 'Pages.Tenant.LockLogs'
                    }
                ]
            },
            {
                label: 'Opciones del sistema',
                icon: 'pi pi-cog',
                items: [
                    {
                        label: this.l('ProgramasProcesoSecuenciado.Title'),
                        icon: 'pi pi-refresh',
                        routerLink: ['/app/catalog/programas-proceso-secuenciado'],
                        permissionName: 'Pages.Tenant.ProgramasEnSecuenciado'
                    },
                    {
                        label: this.l('PartesRecuperacion.Title'),
                        icon: 'pi pi-replay',
                        routerLink: ['/app/sistema/partes-recuperacion'],
                        permissionName: 'Pages.Tenant.PartesEnRecuperacion'
                    },
                    {
                        label: 'Auditorías de Calidad abiertas',
                        icon: 'pi pi-lock-open',
                        routerLink: ['/app/sistema/auditorias-abandonadas'],
                        permissionName: 'Pages.Tenant.AuditoriaCalidad.Abandonadas'
                    },
                    {
                        label: this.l('SesionesMoviles.Title'),
                        icon: 'pi pi-mobile',
                        routerLink: ['/app/sistema/sesiones-dispositivos-moviles'],
                        permissionName: 'Pages.Tenant.AppMovil.Session'
                    }
                ]
            }
        ];
    }

    private getMenuFord(): any[] {
        return [
            {
                label: this.l('Dashboard'),
                icon: 'pi pi-chart-bar',
                routerLink: ['/app/main/dashboard'],
                permissionName: 'Pages.Tenant.Dashboard'
            },
            {
                label: this.l('Instances'),
                icon: 'fa fa-th',
                routerLink: ['/app/admin/tenant'],
                permissionName: 'Pages.Tenants',
                visible: AppConsts.isHost
            },
            {
                label: this.l('Administration'), icon: 'pi pi-briefcase',
                items: [
                    {
                        label: this.l('Roles'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/admin/roles'],
                        permissionName: 'Pages.Administration.Roles'
                    },
                    {
                        label: this.l('Languages'),
                        icon: 'pi pi-comment',
                        routerLink: ['/app/admin/languages'],
                        permissionName: 'Pages.Administration.Languages'
                    },
                    {
                        label: this.l('Users'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/admin/users'],
                        permissionName: 'Pages.Administration.Users'
                    },
                    {
                        label: this.l('OrgUnits'),
                        icon: 'pi pi-sitemap',
                        routerLink: ['/app/admin/orgunits'],
                        permissionName: 'Pages.Administration.OrgUnits'
                    },
                    {
                        label: this.l('AuditLogs'),
                        icon: 'pi pi-lock',
                        routerLink: ['/app/admin/auditLogs'],
                        permissionName: 'Pages.Administration.AuditLogs'
                    },
                    {
                        label: this.l('Maintenance'),
                        icon: 'fa fa-fw fa-wrench',
                        routerLink: ['/app/admin/maintenance'],
                        permissionName: 'Pages.Administration.Host.Maintenance',
                        visible: !(AppConsts.multiTenancy && AppConsts.tenancyName)
                    },
                    {
                        label: this.l('Host.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/admin/host/settings'],
                        permissionName: 'Pages.Administration.Host.Settings',
                        visible: AppConsts.isHost
                    },
                    {
                        label: this.l('Tenant.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/admin/tenants/settings'],
                        permissionName: 'Pages.Administration.Tenant.Settings'
                    },
                    {
                        label: this.l('EmailGroups'),
                        icon: 'pi pi-envelope',
                        routerLink: ['/app/admin/emailgroups'],
                        permissionName: 'conftcor.0'
                    },
                    {
                        label: this.l('Helps'),
                        icon: 'pi pi-question',
                        routerLink: ['/app/admin/helps'],
                        permissionName: 'Pages.Administration.Helps'
                    }
                ]
            },
            {
                label: this.l('Catalogs'), icon: 'pi pi-briefcase',
                items: [
                    {
                        label: this.l('WorkShifts'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/workshifts'],
                        permissionName: 'Pages.Tenant.WorkShifts'
                    },
                    {
                        label: this.l('Almacenes'),
                        icon: 'pi pi-home',
                        routerLink: ['/app/catalog/almacen'],
                        permissionName: 'Pages.Tenant.Almacenes'
                    },
                    {
                        label: this.l('Zones'),
                        icon: 'pi pi-map',
                        routerLink: ['/app/catalog/zones'],
                        permissionName: 'Pages.Tenant.Zones'
                    },
                    {
                        label: this.l('Areas'),
                        icon: 'pi pi-map-marker',
                        routerLink: ['/app/catalog/areas'],
                        permissionName: 'Pages.Tenant.Areas'
                    },
                    {
                        label: this.l('LocationTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/locationtypes'],
                        permissionName: 'Pages.Tenant.LocationTypes'
                    },
                    {
                        label: this.l('Locations'),
                        icon: 'pi pi-flag',
                        routerLink: ['/app/catalog/locations'],
                        permissionName: 'Pages.Tenant.Locations'
                    },
                    {
                        label: this.l('Platforms'),
                        icon: 'pi pi-table',
                        routerLink: ['/app/catalog/platforms'],
                        permissionName: 'Pages.Tenant.Platforms'
                    },
                    {
                        label: this.l('Parts'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/parts'],
                        permissionName: 'Pages.Tenant.Parts'
                    },
                    {
                        label: this.l('PartsMexi'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/partsMexi'],
                        permissionName: 'Pages.Tenant.PartsMexi'
                    },
                    {
                        label: this.l('Mobiles'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/mobiles'],
                        permissionName: 'Pages.Tenant.Mobiles'
                    },
                    {
                        label: this.l('ActivityTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/activitytypes'],
                        permissionName: 'Pages.Tenant.ActivityTypes'
                    },
                    {
                        label: this.l('Providers'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/providers'],
                        permissionName: 'Pages.Tenant.Providers'
                    },
                    {
                        label: this.l('StoreMovementTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/storemovementtypes'],
                        permissionName: 'Pages.Tenant.StoreMovementTypes'
                    },
                    {
                        label: this.l('DamageTypes'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/damagetypes'],
                        permissionName: 'Pages.Tenant.DamageTypes'
                    },
                    {
                        label: this.l('ReasonsSuspension'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/reasonssuspension'],
                        permissionName: 'Pages.Tenant.ReasonsSuspension'
                    },
                    {
                        label: this.l('MarketMaxAndMins'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/marketmaxandmins'],
                        permissionName: 'Pages.Tenant.MarketMaxAndMins'
                    },
                    {
                        label: this.l('CausaFaltante'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante'],
                        permissionName: 'Pages.Tenant.Catalogs.CausaFaltante'
                    },
                    {
                        label: this.l('CausaFaltante.Edit'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante/edit'],
                        permissionName: 'Pages.Tenant.CausaFaltante.Edit'
                    },
                    {
                        label: this.l('CausaFaltante.Create'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/causafaltante/create'],
                        permissionName: 'Pages.Tenant.CausaFaltante.Create'
                    },
                    {
                        label: this.l('Commodities'),
                        icon: 'pi pi-th-large',
                        routerLink: ['/app/catalog/commodities'],
                        permissionName: 'Pages.Tenant.Commodities'
                    },
                    {
                        label: this.l('CommodityMexis'),
                        icon: 'pi pi-th-large',
                        routerLink: ['/app/catalog/commoditymexi'],
                        permissionName: 'Pages.Tenant.CommodityMexis'
                    },
                    {
                        label: this.l('CommodityGroups'),
                        icon: 'pi pi-tags',
                        routerLink: ['/app/catalog/commoditygroups'],
                        permissionName: 'Pages.Tenant.CommodityGroups'
                    },
                    {
                        label: this.l('Cajas'),
                        icon: 'pi pi-box',
                        routerLink: ['/app/catalog/caja'],
                        permissionName: 'Pages.Tenant.Caja'
                    },
                    {
                        label: this.l('BoatProductionProgram'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/catalog/programaproduccionbote'],
                        permissionName: 'Pages.Tenant.ProgramaProduccionBote'
                    },
                    {
                        label: this.l('Routes'),
                        icon: 'pi pi-directions',
                        routerLink: ['/app/catalog/routes'],
                        permissionName: 'Pages.Tenant.Routes'
                    },
                    {
                        label: this.l('Returnables'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/catalog/returnables'],
                        permissionName: 'Pages.Tenant.Returnables'
                    },
                    {
                        label: this.l('GrupoInventario'),
                        icon: 'pi pi-table',
                        routerLink: ['/app/catalog/grupoinventario'],
                        permissionName: 'Pages.Tenant.GrupoInventario'
                    },
                    {
                        label: this.l('Modelo'),
                        icon: 'pi pi-bookmark',
                        routerLink: ['/app/catalog/modelo'],
                        permissionName: 'Pages.Tenant.Modelo'
                    },
                    {
                        label: this.l('PPFrames'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/catalog/ppframes'],
                        permissionName: 'Pages.Tenant.PPFrames'
                    },
                    {
                        label: this.l('TaktTime'),
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/takttime'],
                        permissionName: 'Pages.Tenant.TaktTime'
                    },
                    {
                        label: this.l('Detallado.Fusion.Menu'),
                        icon: 'pi pi-copy',
                        routerLink: ['/app/catalog/detallado-fusion'],
                        permissionName: 'Pages.Tenant.Uploads.Detallado.Fusion'
                    },
                    {
                        label: this.l('Tractors'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/catalog/tractors'],
                        permissionName: 'Pages.Tenant.Uploads.Tractor'
                    },
                    {
                        label: this.l('DollyClasificacion'),
                        icon: 'pi pi-tag',
                        routerLink: ['/app/catalog/dollyclasificacion'],
                        permissionName: 'Pages.Tenant.DollyClasificacion'
                    },
                    {
                        label: this.l('LineaProduccion'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/catalog/lineaproduccion'],
                        permissionName: 'Pages.Tenant.LineaProduccion'
                    },
                    {
                        label: this.l('SecuenciaActualLineaProduccion.SecuenciaActualLineaProduccion'),
                        icon: 'pi pi-sort-numeric-down',
                        routerLink: ['/app/catalog/secuencia-actual-linea-produccion'],
                        permissionName: 'Pages.Tenant.SecuenciaActualLineaProduccion'
                    },
                    {
                        label: this.l('Pages.Tenant.Etiquetas'),
                        icon: 'pi pi-tag',
                        routerLink: ['/app/catalog/etiquetas'],
                        permissionName: 'Pages.Tenant.Etiquetas'
                    },
                    {
                        label: this.l('Pages.Tenant.EscanearMarcarFaltantes'),
                        icon: 'pi pi-search',
                        routerLink: ['/app/catalog/escanear-marcar-faltantes'],
                        permissionName: 'Pages.Tenant.EscanearMarcarFaltantes'
                    },
                    {
                        label: this.l('Chofer'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/catalog/chofer'],
                        permissionName: 'Pages.Tenant.Chofer'
                    },
                    {
                        label: this.l('Uploads.NumeroPartes'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/uploads/numero-partes'],
                        permissionName: 'Pages.Tenant.Uploads.NumeroPartes'
                    },
                    {
                        label: this.l('Uploads.Detallado'),
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/uploads/detallado'],
                        permissionName: 'Pages.Tenant.Uploads.Detallado'
                    },
                    {
                        label: 'Línea Transportista',
                        icon: 'pi pi-ellipsis-h',
                        routerLink: ['/app/catalog/lineatransportista'],
                        permissionName: 'Pages.Tenant.LineaTransportista'
                    },
                    // ===== SISTEMA (movidos desde Opciones del sistema) =====
                    {
                        label: 'Hora de Comida',
                        icon: 'pi pi-clock',
                        routerLink: ['/app/catalog/hora-comida']
                        // permissionName: 'Pages.Tenant.HoraDeComida'  // Comentado para prueba
                    },
                    {
                        label: this.l('HorarioDeProduccion'),
                        icon: 'pi pi-calendar-plus',
                        routerLink: ['/app/catalog/horario-produccion'],
                        permissionName: 'Pages.Tenant.HorarioDeProduccion'
                    },
                    {
                        label: this.l('DiasInhabiles'),
                        icon: 'pi pi-calendar-times',
                        routerLink: ['/app/catalog/dias-inhabiles'],
                        permissionName: 'Pages.Tenant.DiasInhabiles'
                    }
                ]
            },
            {
                label: this.l('Uploads.Campus'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.Campus',
                items: [
                    {
                        label: this.l('Uploads.Campus'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/campus'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    },
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/campus/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    },
                    {
                        label: this.l('Uploads.LogSuccess'),
                        icon: 'pi pi-check-circle',
                        routerLink: ['/app/uploads/campus/logsuccess'],
                        permissionName: 'Pages.Tenant.Uploads.Campus'
                    }
                ]
            },
            {
                label: this.l('Uploads.Inbound'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.Inbound',
                items: [
                    {
                        label: this.l('Uploads.Inbound'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/inbound'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    },
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/inbound/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    },
                    {
                        label: this.l('Uploads.LogSuccess'),
                        icon: 'pi pi-check-circle',
                        routerLink: ['/app/uploads/inbound/logsuccess'],
                        permissionName: 'Pages.Tenant.Uploads.Inbound'
                    }
                ]
            },
           /* {
                label: this.l('Uploads.NumeroPartes'),
                icon: 'pi pi-upload',
                permissionName: 'Pages.Tenant.Uploads.NumeroPartes',
                items: [
                    {
                        label: this.l('Uploads.NumeroPartes'),
                        icon: 'pi pi-upload',
                        routerLink: ['/app/uploads/numero-partes'],
                        permissionName: 'Pages.Tenant.Uploads.NumeroPartes'
                    }
                ]
            },*/
            {
                label: this.l('Uploads.LogsGenerales'),
                icon: 'pi pi-times-circle',
                permissionName: 'Pages.Tenant.Uploads.LogsGenerales',
                items: [
                    {
                        label: this.l('Uploads.LogErrors'),
                        icon: 'pi pi-times-circle',
                        routerLink: ['/app/uploads/general/logerrors'],
                        permissionName: 'Pages.Tenant.Uploads.LogsGenerales'
                    }
                ]
            },
            {
                label: this.l('DownloadSchedules.Downloads'),
                icon: 'pi pi-download',
                permissionName: 'Pages.Tenant.DownloadSchedules',
                items: [
                    {
                        label: this.l('DownloadSchedules.Schedule'),
                        icon: 'pi pi-calendar',
                        routerLink: ['/app/downloads/schedules'],
                        permissionName: 'Pages.Tenant.DownloadSchedules'
                    },
                    {
                        label: this.l('DownloadDepuration.Depurate'),
                        icon: 'pi pi-check-square',
                        routerLink: ['/app/downloads/depuration'],
                        permissionName: 'Pages.Tenant.DownloadDepuration'
                    }
                ]
            },
            {
                label: this.l('Reports'),
                icon: 'pi pi-file',
                permissionName: 'Pages.Tenant.Reports',
                items: [
                    {
                        label: this.l('Reports.Stocked'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/stocked'],
                        permissionName: 'Pages.Tenant.Reports.Stocked'
                    },
                    {
                        label: this.l('Reports.Download'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/download'],
                        permissionName: 'Pages.Tenant.Reports.Download'
                    },
                    {
                        label: this.l('Reports.Putaway'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/putaway'],
                        permissionName: 'Pages.Tenant.Reports.Putaway'
                    },
                    {
                        label: this.l('Reports.JIT'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/jit'],
                        permissionName: 'Pages.Tenant.Reports.JIT'
                    },
                    {
                        label: this.l('Reports.Empty'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/empty'],
                        permissionName: 'Pages.Tenant.Reports.Empty'
                    },
                    {
                        label: this.l('Reports.LocationStock'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/locationstock'],
                        permissionName: 'Pages.Tenant.Reports.LocationStock'
                    },
                    {
                        label: this.l('Reports.WarehouseMovement'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/warehousemovement'],
                        permissionName: 'Pages.Tenant.Reports.WarehouseMovement'
                    },
                    {
                        label: this.l('Reports.TimeInStock'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/timeinstock'],
                        permissionName: 'Pages.Tenant.Reports.TimeInStock'
                    },
                    {
                        label: this.l('Reports.MaxMin'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/maxmin'],
                        permissionName: 'Pages.Tenant.Reports.MaxMin'
                    },
                    {
                        label: this.l('Reports.Activity'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/activity'],
                        permissionName: 'Pages.Tenant.Reports.Activity'
                    },
                    {
                        label: this.l('Reports.SupplyCardDelivery'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/supplycarddelivery'],
                        permissionName: 'Pages.Tenant.Reports.SupplyCardDelivery'
                    },
                    {
                        label: this.l('Reports.ReasonRestartLog'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/reports/reasonrestartlog'],
                        permissionName: 'Pages.Tenant.Reports.ReasonRestartLog'
                    }
                ]
            },
            {
                label: this.l('SupplyCards'),
                icon: 'pi pi-credit-card',
                permissionName: 'Pages.Tenant.SupplyCards',
                items: [
                    {
                        label: this.l('SupplyCards.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/supplycards/configuration'],
                        permissionName: 'Pages.Tenant.SupplyCards.Settings'
                    },
                    {
                        label: this.l('SupplyCards.Routes'),
                        icon: 'pi pi-directions',
                        routerLink: ['/app/supplycards/routes'],
                        permissionName: 'Pages.Tenant.SupplyCardRoutes'
                    }
                ]
            },
            {
                label: this.l('Locks'),
                icon: 'pi pi-cog',
                permissionName: 'Pages.Tenant.Locks',
                items: [
                    {
                        label: this.l('Locks'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/locks/locks'],
                        permissionName: 'Pages.Tenant.Locks'
                    },
                    {
                        label: this.l('LockLogs'),
                        icon: 'pi pi-file-excel',
                        routerLink: ['/app/locks/logs'],
                        permissionName: 'Pages.Tenant.LockLogs'
                    }
                ]
            },
            {
                label: 'Opciones del sistema',
                icon: 'pi pi-cog',
                items: [
                    {
                        label: this.l('ProgramasProcesoSecuenciado.Title'),
                        icon: 'pi pi-refresh',
                        routerLink: ['/app/catalog/programas-proceso-secuenciado'],
                        permissionName: 'Pages.Tenant.ProgramasEnSecuenciado'
                    },
                    {
                        label: this.l('PartesRecuperacion.Title'),
                        icon: 'pi pi-replay',
                        routerLink: ['/app/sistema/partes-recuperacion'],
                        permissionName: 'Pages.Tenant.PartesEnRecuperacion'
                    }
                ]
            }
        ];
    }

    ngAfterViewInit() {
        setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 100);
    }

    onMenuClick(event) {
        if (!this.app.isHorizontal()) {
            setTimeout(() => {
                this.layoutMenuScrollerViewChild.moveBar();
            }, 450);
        }
        this.app.onMenuClick(event);
    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-submenu]',
    /* tslint:enable:component-selector */
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li *ngIf="showMenuItem(child)" [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)"
                   *ngIf="!child.routerLink" [ngClass]="child.styleClass"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon" class="layout-menuitem-icon"></i>
                    <span class="layout-menuitem-text">{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>
                <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" *ngIf="child.routerLink"
                   [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink" [fragment]="child.fragment"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon" class="layout-menuitem-icon"></i>
                    <span class="layout-menuitem-text">{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{child.label}}</div>
                </div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset" [parentActive]="isActive(i)"
                    [@children]="(app.isSlim()||app.isHorizontal())&&root ? isActive(i) ?
                    'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*',
                'z-index': 100
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent extends AppComponentBase {
    @Input() item: MenuItem;
    @Input() root: boolean;
    @Input() visible: boolean;
    _parentActive: boolean;
    _reset: boolean;
    activeIndex: number;
    constructor(injector: Injector, public app: AppComponent, public appMenu: AppMenuComponent, public router: Router) { super(injector); }
    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }
        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;
        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }
        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.appMenu.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }
            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        if (item['reloadAlways']) {
            this.app.redirectTo(item.routerLink);
        }
    }
    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())
            && !this.app.isMobile() && !this.app.isTablet()) {
            this.activeIndex = index;
        }
    }
    isActive(index: number): boolean {
        return this.activeIndex === index;
    }
    @Input() get reset(): boolean {
        return this._reset;
    }
    set reset(val: boolean) {
        this._reset = val;
        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }
    @Input() get parentActive(): boolean {
        return this._parentActive;
    }
    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }

    showMenuItem(menuItem): boolean {

        if (menuItem.visible === false) {
            return false;
        }

        if (menuItem.permissionName) {
            return this.permission.isGranted(menuItem.permissionName);
        }

        if (menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return true;
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (let i = 0; i < menuItem.items.length; i++) {
            const subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName && this.permission.isGranted(subMenuItem.permissionName) && subMenuItem.visible !== false) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            } else if (!subMenuItem.permissionName) {
                return true;
            }
        }

        return false;
    }
}
